module.exports = "<md-list>\n    <md-list-item class=\"md-2-line\" ng-repeat=\"stat in vm.stats\">\n        <div class=\"md-list-item-text\">\n            <h3>{{stat.label}}</h3>\n            <span ng-if=\"stat.useItemSize\">{{stat.count | pxItemSize}}</span>\n            <span ng-if=\"!stat.useItemSize\">{{stat.count}}</span>\n        </div>\n    </md-list-item>\n</md-list>";


//////////////////
// WEBPACK FOOTER
// ./src/sharebase/components/myAccount/statsList/statsList.template.html
// module id = 1079
// module chunks = 0